var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamsungpay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg120",
    width: 419.44772,
    height: 188.32899,
    viewBox: "0 0 419.44773 188.329",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs124"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,173.54 H 364.657 V 0 H 0 Z",
    id: "path134"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g128",
    transform: "matrix(1.3333333,0,0,-1.3333333,-33.381199,198.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g130",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132",
    clipPath: "url(#clipPath136)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(40.9198,47.0918)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -6.848 V 17.713 H 0 c 5.333,0 8.955,-3.952 8.955,-8.823 C 8.955,3.95 5.333,0 0,0 m 0.658,26.008 h -16.461 v -48.065 h 8.955 v 13.761 h 7.44 c 10.008,0 17.383,7.637 17.383,17.186 0,9.48 -7.375,17.118 -17.317,17.118",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(81.6811,32.4102)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.584,0 -11.652,5.267 -11.652,11.982 0,6.65 5.068,11.851 11.652,11.851 6.584,0 11.523,-5.332 11.523,-11.851 C 11.523,5.332 6.584,0 0,0 m 11.063,26.533 c -2.766,3.292 -7.31,5.401 -12.378,5.401 -9.746,0 -19.095,-7.31 -19.095,-20.083 0,-12.577 9.678,-20.017 18.962,-20.017 5.07,0 9.679,2.239 12.511,5.794 v -5.003 h 8.888 v 38.518 h -8.888 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g146",
    transform: "translate(125.4086,37.6114)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -10.732,25.941 h -9.482 l 15.803,-36.608 -8.1,-19.687 h 9.022 L 19.49,25.941 h -9.35 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g150",
    transform: "translate(285.4232,111.7813)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -0.247 L -10.58,35.291 H -27.268 V -9.204 h 11.058 l -0.621,36.509 h 0.247 L -5.485,-9.204 H 10.524 V 35.291 H -0.61 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g154",
    transform: "translate(83.1376,142.9073)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0.251,0.004 6.245,-40.792 H 18.323 L 10.036,4.165 H -9.966 L -18.3,-40.792 h 12.152 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g158",
    transform: "translate(141.1044,147.0723)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -5.545,-34.377 H -5.801 L -11.338,0 h -18.338 l -0.991,-44.957 h 11.253 l 0.281,40.415 h 0.248 l 7.51,-40.415 H 0.033 l 7.513,40.411 0.248,0.004 0.281,-40.415 H 19.321 L 18.33,0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path160"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g162",
    transform: "translate(41.3759,100.3555)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 8.135,0 14.823,2.774 15.892,10.28 0.547,3.88 0.145,6.422 -0.048,7.368 -1.898,9.415 -18.955,12.223 -20.228,17.488 -0.214,0.913 -0.162,1.86 -0.048,2.363 0.318,1.443 1.295,3.019 4.106,3.019 2.634,0 4.177,-1.624 4.177,-4.074 v -2.785 h 11.22 v 3.167 c 0,9.792 -8.797,11.323 -15.16,11.323 -7.99,0 -14.527,-2.648 -15.718,-9.98 -0.326,-2.005 -0.37,-3.8 0.103,-6.064 1.95,-9.189 17.927,-11.844 20.243,-17.664 0.44,-1.087 0.3,-2.481 0.089,-3.325 C 4.262,9.618 3.244,8.09 0.248,8.09 c -2.811,0 -4.517,1.628 -4.517,4.077 L -4.28,16.524 H -16.336 L -16.34,13.059 C -16.34,3.029 -8.449,0 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(183.2533,135.377)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.218,0.898 -0.163,1.834 -0.056,2.334 0.319,1.428 1.288,2.989 4.066,2.989 2.615,0 4.139,-1.602 4.139,-4.033 v -2.752 h 11.11 v 3.13 c 0,9.695 -8.712,11.209 -15.012,11.209 -7.905,0 -14.379,-2.615 -15.556,-9.877 -0.325,-1.986 -0.37,-3.763 0.104,-6.001 1.924,-9.103 17.746,-11.73 20.039,-17.493 0.43,-1.08 0.296,-2.453 0.085,-3.293 -0.362,-1.48 -1.368,-2.988 -4.335,-2.988 -2.786,0 -4.477,1.605 -4.477,4.035 L 0.1,-18.431 h -11.938 l -0.003,-3.432 c 0,-9.929 7.817,-12.925 16.181,-12.925 8.053,0 14.675,2.744 15.732,10.177 0.54,3.84 0.145,6.355 -0.048,7.298 C 18.142,-7.99 1.255,-5.213 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path168"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g170",
    transform: "translate(245.6264,147.0801)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -11.379 v -33.26 c 0.004,-0.577 -0.012,-1.232 -0.107,-1.717 -0.223,-1.106 -1.184,-3.258 -4.31,-3.258 h -0.001 c -3.129,0 -4.095,2.152 -4.313,3.258 -0.096,0.485 -0.119,1.14 -0.108,1.717 V 0 h -11.371 v -32.235 c -0.022,-0.829 0.064,-2.52 0.104,-2.959 0.788,-8.391 7.421,-11.11 15.689,-11.11 8.264,0 14.897,2.719 15.681,11.11 0.045,0.439 0.13,2.13 0.115,2.959 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path172"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g174",
    transform: "translate(323.6957,127.3643)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -6.555 h 4.609 v -6.529 c 0.008,-0.569 -0.014,-1.198 -0.107,-1.705 -0.203,-1.203 -1.339,-3.264 -4.595,-3.264 -3.251,0 -4.386,2.061 -4.597,3.263 -0.086,0.507 -0.108,1.136 -0.105,1.706 V 7.469 c 0,0.732 0.053,1.536 0.182,2.128 0.248,1.109 1.21,3.262 4.479,3.262 3.438,0 4.292,-2.271 4.495,-3.262 C 4.495,8.949 4.506,7.88 4.502,7.884 v -2.52 h 11.339 v 1.498 c -0.008,0 0.04,1.528 -0.104,2.96 -0.829,8.431 -7.809,11.109 -15.781,11.109 -7.977,0 -14.779,-2.704 -15.781,-11.109 -0.093,-0.751 -0.19,-2.161 -0.19,-2.96 l -0.003,-18.914 c 0.003,-0.847 0.026,-1.465 0.156,-2.96 0.751,-8.19 7.841,-11.112 15.814,-11.112 7.968,0 15.068,2.923 15.811,11.112 0.136,1.495 0.155,2.113 0.163,2.96 V 0 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path176"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsungpay);
export default __webpack_public_path__ + "static/media/samsungpay.62ed0402334dcbe85a968a41bf974951.svg";
export { ForwardRef as ReactComponent };